<template>
  <div>
    <h1>Error</h1>
  </div>
</template>
